<script>
export default {
  name: 'ImageViewer',
  props: {
    currentTime: Number,
    imgBasePath: String,
  },
  watch: {
    currentTime() {

    }
  },
  methods: {
    getImgUrl: function(currentTime, imgBasePath) {
      let imageNumber = this.getImageNumber(currentTime);
      return require('@/assets/photos' + imgBasePath + '/' + imageNumber + '.jpg');
    },
    getImageNumber(currentTime) {
      if (!isNaN(currentTime)) {
        return Math.floor(parseInt(currentTime) / 600) * 600;
      } 
      return 0;
    }
  }
};
</script>

<template>
  <div class="img-viewer">
    <img :src="getImgUrl(currentTime, imgBasePath)">
  </div>
</template>

<style scoped lang="scss">
  @import "../assets/styles/variables";

  .img-viewer {
    width: 100%;
    height: 100%;
    background-color: var(--dark);
    background-position: center;
    background-size: cover;
    // filter: grayscale(10%);

    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 60%;
      opacity: .3;
      background: linear-gradient(180deg, rgba(33,33,50,1) 10%, rgba(0,0,0,0) 100%);
    }
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>
